import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { auditLogs } from "@/lib/apiData";

export default function AuditLogs() {
  const [q, setQ] = useState("");
  const { data: logs = [], isLoading } = useQuery({ queryKey: ["audit-logs", q], queryFn: () => auditLogs(q) });
  return (
    <div data-testid="admin-audit-panel">
      <h2 className="font-display text-3xl font-black text-neutral-900">Audit log</h2>
      <p className="text-neutral-500 text-sm mt-1 mb-6">Every team sign-in and every change made in the admin, newest first.</p>
      <div className="relative max-w-sm mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by person or action" data-testid="audit-search" className="pl-9 h-10 bg-white border-neutral-300 rounded-none" />
      </div>
      <div className="bg-white border border-neutral-200 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Who</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead><TableHead>IP</TableHead></TableRow></TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid="audit-row">
                <TableCell className="text-neutral-500 text-sm whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-neutral-900">{l.actor}</TableCell>
                <TableCell><span className={`text-xs px-2 py-1 ${l.action.includes("delete") || l.action.includes("failed") ? "bg-[#d00000]/10 text-[#d00000]" : "bg-neutral-100 text-neutral-700"}`}>{l.action}</span></TableCell>
                <TableCell className="text-neutral-600 text-sm max-w-xs truncate">{l.detail}</TableCell>
                <TableCell className="text-neutral-400 text-xs">{l.ip}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!isLoading && logs.length === 0 && <p className="p-8 text-center text-neutral-400">No activity found.</p>}
      </div>
    </div>
  );
}
